<template>
            <div class="join_wrap">
                <article class="view" v-show="currentStep === 0">
                    <div class="title pb10">
                        <h2>이용약관 및 정보이용에 대한 약관을 확인하세요</h2>
                        <p><strong>코끼리 원외탕전</strong>은 이용자의 개인정보를 중요시하며, "정보통신망 이용촉진 및 정보보호 등에 관한 법률" 등  <br> 개인정보와 관련된 법령 상의 개인정보보호규정 및 방송통신위원회가 제정한 "개인정보보호지침"을 준수하고 있습니다.</p>
                    </div>
                    <pre class="form_control">
[서비스 이용약관]

제 1 장 총칙

제 1조 (목적)

본 약관은 서비스(이하 "회사"라 한다)는 홈페이지에서 제공하는 서비스(이하 "서비스"라 한다)를 제공함에 있어 회사와 이용자의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.

제 2조 (용어의 정의)

1. 본 약관에서 사용하는 용어의 정의는 다음과 같습니다.
'서비스'란 회사가 이용자에게 서비스를 제공하기 위하여 컴퓨터 등 정보통신설비를 이용하여 구성한 가상의 공간을 의미하며, 서비스 자체를 의미하기도 합니다.
'회원(이하 "회원"이라 한다)'이란 개인정보를 제공하여 회원등록을 한 자로서 홈페이지의 정보를 지속적으로 제공받으며 홈페이지가 제공하는 서비스를 계속적으로 이용할 수 있는 자를 말합니다.
'아이디(이하 "ID"라 한다)'란 회원의 식별과 회원의 서비스 이용을 위하여 회원이 선정하고 회사가 승인하는 회원 고유의 계정 정보를 의미합니다.
'비밀번호'란 회원이 부여 받은 ID와 일치된 회원임을 확인하고, 회원의 개인정보를 보호하기 위하여 회원이 정한 문자와 숫자의 조합을 의미합니다.
'회원탈퇴(이하 "탈퇴"라 한다)'란 회원이 이용계약을 해지하는 것을 의미합니다.

2. 본 약관에서 사용하는 용어의 정의는 제1항에서 정하는 것을 제외하고는 관계법령 및 서비스 별 안내에서 정하는 바에 의합니다.
                    </pre>
                    <div class="title pb10 fwb">
                        <h3>알려드립니다</h3>
                    </div>   
                    <pre class="form_control">
의료기관을 제외한 가입자는 처방을 하실 수 없습니다.

의료기관의 경우 계약서와 사업자등록증을 보내주셔야 관리자의 승인이 이루어집니다.

<strong>코끼리 원외탕전</strong>에서는 법률 준수 및 고객님의 개인정보 보호를 위해 홈페이지 내에서 <strong>주민등록 번호 수집 및 입력을 요구하지 않습니다</strong>.
개정 "주민등록번호"에 의해 타인의 주민등록번호를 부정 사용하는 자는 3년 이하의 징역 또는 1천만원 이하의 벌금이 부과될 수 있습니다.
                    </pre>  
                    <div class="btn_box">
                        <button class="btn btn_md btn_brown btn_outline" @click="fn_move_main">동의하지 않습니다.</button>
                        <button class="btn btn_md btn_brown" @click="fn_move_tab(1)">동의합니다.</button>
                    </div>    
                </article>
                <article class="view" v-show="currentStep === 1">
                    <div class="title">
                        <h2>회원 구분</h2>
                        <p>
                            이 사이트는 한의사 및 한방의료기관을 위해 전문서비스를 제공하고 있습니다. 따라서 일반일은 이용하실 수 없습니다. 
                            <br><strong>의료기관의 경우 계약서와 사업자등록증을 보내주셔야 관리자의 승인이 이루어집니다.</strong>
                        </p>
                    </div>                    
                    <ul class="quick_menu">
                        <li v-for="(menu, idx) in menuList" :key="idx"
                            @click="selected = idx"
                            :class="{ active:selected === idx}" 
                        >
                            <a>
                                <p>
                                    <span>
                                        <b-icon icon="check-circle-fill"></b-icon>
                                        <strong>{{ menu.title }}</strong>
                                    </span>
                                    {{ menu.subTitle }} 
                                </p>
                            </a>
                        </li>
                    </ul>   
                    <div class="pt30">
                        <p v-if="selected !== null">
                            <strong>{{ menuList[selected].title }}</strong>
                            : {{ menuList[selected].subTitle }}을(를) 선택하셨습니다.
                        </p>
                        <p v-else class="txt_info">
                            코끼리 원외탕전 회원으로 가입하실 유형을 선택하여 주세요.
                        </p>
                    </div>
                    <div class="auth pt30" v-show="selected !== null">
                        <div class="title">
                            <h2>회원 검증</h2>
                            <p v-if="selected == 0">
                                한방의료기관임을 확인하고 코끼리 원외탕전 사이트에 이미 가입되어 있는지를 확인하기 위한 절차입니다.
                                <br><strong> 반드시 입력하여 주세요.</strong>
                            </p>
                            <p v-if="selected == 1">
                                코끼리 원외탕전 가입여부를 확인하기 위한 절차입니다.
                                <br><strong> 반드시 입력하여 주세요.</strong>
                            </p>                             
                        </div>
                        <div>
                            <div class="form_inline" v-if="selected === 0">
                                <p class="fwb w50">사업자번호</p>
                                <input type="text" pattern="\d*" maxlength="3" class="form_control" v-model="bizRegNum1" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');">
                                -
                                <input type="text" pattern="\d*" maxlength="2" class="form_control" v-model="bizRegNum2" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');">
                                -
                                <input type="text" pattern="\d*" maxlength="5" class="form_control" v-model="bizRegNum3" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');">
                            </div>
                            <div class="form_inline" v-else>
                                <p class="fwb w50">이름</p>
                                <input type="text" class="form_control" v-model="dispsrMbrInfo.doctor_nm">
                                <p class="fwb w50 ml30">면허 번호</p>
                                <input type="text" class="form_control" maxlength="5" v-model="dispsrMbrInfo.licenseNo" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');">
                            </div>
                        </div>
                        <div class="btn_box pt50">
                            <button class="btn btn_md btn_brown" @click="fn_userchk()">회원 검증</button
                        ></div>
                    </div>
                </article>
                <article class="view" v-show="currentStep === 2">
                    <div class="title">
                        <h2>{{ joinUserDivision }} 회원가입을 진행합니다.</h2>
                        <p class="txt_info" v-if="selected === 0">
                            의료기관의 정보를 입력하는 화면입니다. 전자계산서를 받을 수 있는 의료기관용 이메일을 정확하게 입력해 주세요.
                            <br><strong>의료기관임을 증명할 수 있는 사업자등록증과 한의사면허증을 보내주셔야 회원가입이 완료됩니다.</strong>
                            <br>팩스) 0*-****-**** / 이메일) ******@daum.net / 카카오톡ID) elephant
                        </p>
                        <p class="txt_info" v-else>
                            공동탕전실은 의료기관의 부설시설로 의료기관에 소속된 한의사만이 처방을 의뢰할 수 있으며 
                            <br>의약품의 도매 및 소매는 한방의료기관 및 약국개설자와 그 외 법에서 인정하는 경우에만 허용이 됩니다. 
                            <br>한의사 면허증을 팩스 0**-****-****, 이메일 ****@daum.net, 또는010-****-**** 문자, 카톡(ID=****) 보내주셔야 회원가입이 완료됩니다.
                            <br> 자세한 내용은 전화로 문의하세요. tel) 0**-***-****
                        </p>
                    </div>
                    <!-- 계정 정보 -->
                    <div class="table_list">
                        <h3 class="tb_title">계정 정보</h3>
                        <table class="write">
                            <colgroup>
                                <col width="200">
                                <col width="30%">
                                <col width="200">
                                <col width="30%">
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th><span class="emp">아이디</span></th>
                                    <td>
                                        <div class="form_inline w100">
                                            <input type="text" class="form_control" v-model="dispsrMbrInfo.clinic_doctor_id" @change="fn_changeId()">
                                            <button class="btn btn_md btn_darkbrown" @click="fn_chkDuplication()">중복확인</button>
                                        </div>
                                    </td>
                                    <td colspan="2"><span class="txt_info">영문,숫자 6~12자리의 아이디를 생성해주세요.</span></td>
                                </tr>
                                <tr>
                                    <th><span class="emp" >비밀번호</span></th>
                                    <td><input type="password" class="form_control" v-model="dispsrMbrInfo.clinic_doctor_pw"></td>
                                    <td colspan="2"><span class="txt_info">아이디에 포함된 문자는 비밀번호 사용에 자제하세요.</span></td>
                                </tr>
                                <tr>
                                    <th><span class="emp">비밀번호 확인</span></th>
                                    <td><input type="password" class="form_control" v-model="dispsrMbrInfo.clinic_doctor_pw_confirm"></td>
                                    <td colspan="2"><span class="txt_info">비밀번호를 한번 더 입력하세요.</span></td>                                    
                                </tr>
                            </tbody>
                        </table>
                    </div>            
                    <!-- 회원 정보 -->
                    <div class="table_list">
                        <h3 class="tb_title">회원 정보</h3>
                        <table class="write">
                            <colgroup>
                                <col width="200">
                                <col width="30%">
                                <col width="200">
                                <col width="30%">
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th><span class="emp">이름</span></th>
                                    <td><input type="text" class="form_control" placeholder="반드시 실명을 입력해주세요." v-model="dispsrMbrInfo.doctor_nm" ></td>
                                    <th><span class="emp">닉네임</span></th>
                                    <td><input type="text" class="form_control" placeholder="닉네임 입력해주세요." v-model="dispsrMbrInfo.nick_nm" ></td>                                 
                                </tr>
                                <tr>
                                </tr>
                                <tr>
                                    <th><span class="emp">성별</span></th>
                                    <td>
                                        <div class="form_inline">
                                            <div class="form_radio">
                                                <input type="radio" id="man" name="radio1" value="M" v-model="dispsrMbrInfo.doctor_gender">
                                                <label for="man">남</label>
                                            </div>
                                            <div class="form_radio">
                                                <input type="radio" id="girl" name="radio1" value="F" v-model="dispsrMbrInfo.doctor_gender">
                                                <label for="girl">여</label>
                                            </div>
                                        </div>                                       
                                    </td>
                                    <th><span class="emp">생년월일</span></th>
                                    <td>
                                        <div class="form_select" style="gap: 10px">
                                            <b-form-select v-model="dispsrMbrInfo.doctor_birth_year" class="w100" @change="fn_updateBirthDays">
                                                <b-form-select-option :value="''">선택</b-form-select-option>
                                                <b-form-select-option v-for="birthYear in birthYearList" :key="birthYear" :value="birthYear">{{birthYear}}</b-form-select-option>
                                            </b-form-select>
                                            <b-form-select v-model="dispsrMbrInfo.doctor_birth_month" class="w100" @change="fn_updateBirthDays">
                                                <b-form-select-option :value="''">선택</b-form-select-option>
                                                <b-form-select-option v-for="birthMonth in birthMonthList" :key="birthMonth" :value="birthMonth">{{birthMonth}}</b-form-select-option>
                                            </b-form-select>
                                            <b-form-select v-model="dispsrMbrInfo.doctor_birth_day" class="w100">
                                                <b-form-select-option :value="''">선택</b-form-select-option>
                                                <b-form-select-option v-for="birthDay in birthDayList" :key="birthDay" :value="birthDay">{{birthDay}}</b-form-select-option>
                                            </b-form-select>
                                        </div> 
                                    </td>
                                </tr>
                                <tr>
                                    <th><span class="emp">면허 번호</span></th>
                                    <td><input type="text" class="form_control" maxlength="5" v-model="dispsrMbrInfo.licenseNo" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');" ></td>
                                    <th><span >발급일자</span></th>
                                    <td><input type="text" class="form_control" v-model="dispsrMbrInfo.issuanceDate"></td>
                                </tr>
                                <tr>
                                    <th><span class="emp">우편번호</span></th>
                                    <td>
                                        <div class="form_inline w100">
                                            <input type="text" class="form_control" v-model="dispsrMbrInfo.doctor_post_no" readonly>
                                            <button class="btn btn_md btn_darkbrown" @click="fn_postSearch('mbr')">주소 찾기</button>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th><span class="emp">주소</span></th>
                                    <td><input type="text" class="form_control" v-model="dispsrMbrInfo.doctor_addr" readonly></td>
                                </tr>
                                <tr>
                                    <th><span>상세주소</span></th>
                                    <td><input type="text" class="form_control w100" v-model="dispsrMbrInfo.doctor_addr_dtl"></td>
                                    <td colspan="2"><span class="txt_info">나머지 주소를 입력해주세요.</span></td>                                    
                                </tr>
                                <tr>
                                    <th><span class="emp">휴대폰번호</span></th>
                                    <td>
                                        <div class="form_select form_inline">
                                            <b-form-select v-model="dispsrMbrCpNo1" class="w100">
                                                <b-form-select-option value="">선택</b-form-select-option>
                                                <b-form-select-option v-for="phonefixes in phonePrefixes" :key="phonefixes" :value="phonefixes">{{phonefixes}}</b-form-select-option>
                                            </b-form-select> -
                                            <input type="text" class="form_control" v-model="dispsrMbrCpNo2" maxlength="4" pattern="[0-9]*" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');">-
                                            <input type="text" class="form_control" v-model="dispsrMbrCpNo3" maxlength="4" pattern="[0-9]*" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');">
                                        </div>                                        
                                    </td>
                                    <th><span>문자 수신</span></th>
                                    <td>
                                        <div class="form_inline">
                                            <div class="form_radio">
                                                <input type="radio" id="mail1" name="radioMessage" value="Y" v-model="dispsrMbrInfo.messageRecvYn">
                                                <label for="mail1">수신</label>
                                            </div>
                                            <div class="form_radio">
                                                <input type="radio" id="mail2" name="radioMessage" value="N" v-model="dispsrMbrInfo.messageRecvYn">
                                                <label for="mail2">수신하지 않음</label>
                                            </div>
                                        </div>                                       
                                    </td>
                                </tr>
                                <tr>
                                    <th><span>전화번호</span></th>
                                    <td>
                                         <div class="form_select form_inline">
                                            <b-form-select v-model="dispsrMbrTelNo1" class="w100">
                                                <b-form-select-option :value="''">선택</b-form-select-option>
                                                <b-form-select-option v-for="areaCode in telAreaCodes" :key="areaCode" :value="areaCode">{{areaCode}}</b-form-select-option>
                                            </b-form-select> -
                                            <input type="text" class="form_control" v-model="dispsrMbrTelNo2" maxlength="4" pattern="[0-9]*" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');">-
                                            <input type="text" class="form_control" v-model="dispsrMbrTelNo3" maxlength="4" pattern="[0-9]*" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');">
                                        </div>     
                                    </td>
                                </tr>
                                <tr>
                                    <th><span>이메일</span></th>
                                    <td>
                                         <div class="form_select form_inline">
                                            <input type="text" class="form_control" v-model="doctor_mail">@
                                            <input type="text" class="form_control" v-model="doctor_mail_domain" :readonly="doctor_select_domain !== ''">
                                            <b-form-select v-model="doctor_select_domain" class="w100" @change="fn_change_mail_domain">
                                                <b-form-select-option :value="''">직접 입력</b-form-select-option>
                                                <b-form-select-option v-for="domain in mailDomain" :key="domain" :value="domain">{{domain}}</b-form-select-option>
                                            </b-form-select> 
                                        </div>     
                                    </td>
                                    <th><span>메일 수신</span></th>
                                    <td>
                                        <div class="form_inline">
                                            <div class="form_radio">
                                                <input type="radio" id="mail1" name="radioMail" value="Y" v-model="dispsrMbrInfo.mailRecvYn">
                                                <label for="mail1">수신</label>
                                            </div>
                                            <div class="form_radio">
                                                <input type="radio" id="mail2" name="radioMail" value="N" v-model="dispsrMbrInfo.mailRecvYn">
                                                <label for="mail2">수신하지 않음</label>
                                            </div>
                                        </div>                                       
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>      
                    <!-- 한의사 정보 -->
                    <!-- <div class="table_list">
                        <h3 class="tb_title">한의사 정보</h3>
                        <table class="write">
                            <colgroup>
                                <col width="200">
                                <col width="30%">
                                <col width="200">
                                <col width="30%">
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th><span class="emp">면허 번호</span></th>
                                    <td><input type="text" class="form_control" v-model="dispsrMbrInfo.licenseNo" readonly></td>
                                </tr>
                                <tr>
                                    <th><span class="emp">면허증 첨부</span></th>
                                    <td>
                                        <div class="form_inline w100">
                                            <input type="text" class="form_control" v-model="dispsrMbrInfo.licenseFileNm" >
                                            <input type="file" ref="licenseFile" @change="fn_fileLicenseChange" hidden>
                                            <button class="btn btn_md btn_darkbrown" @click="fn_licenseFileUpload()">파일첨부</button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>                                       -->
                    <!-- 한의원 정보 -->
                    <div class="table_list" v-show="selected === 0">
                        <h3 class="tb_title">한의원 정보</h3>
                        <table class="write">
                            <colgroup>
                                <col width="200">
                                <col width="30%">
                                <col width="200">
                                <col width="30%">
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th><span class="emp">한의원 명</span></th>
                                    <td><input type="text" class="form_control" v-model="dispsrMbrInfo.clinic_nm"></td>
                                </tr>
                                <tr>
                                    <th><span class="emp">사업자번호</span></th>
                                    <td>
                                        <div class="form_inline">
                                            <input type="number" pattern="\d*" maxlength="3" class="form_control" v-model="bizRegNum1" readonly>-
                                            <input type="number" pattern="\d*" maxlength="2" class="form_control" v-model="bizRegNum2" readonly>-
                                            <input type="number" pattern="\d*" maxlength="5" class="form_control" v-model="bizRegNum3" readonly>
                                        </div>
                                    </td>                                    
                                </tr>
                                <tr>
                                    <th><span class="emp">우편번호</span></th>
                                    <td>
                                        <div class="form_inline w100">
                                            <input type="text" class="form_control" v-model="dispsrMbrInfo.clinic_post_no">
                                            <button class="btn btn_md btn_darkbrown" @click="fn_postSearch('clinc')">주소 찾기</button>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th><span class="emp">주소</span></th>
                                    <td><input type="text" class="form_control" v-model="dispsrMbrInfo.clinic_addr"></td>
                                </tr>
                                <tr>
                                    <th><span>상세주소</span></th>
                                    <td><input type="text" class="form_control" v-model="dispsrMbrInfo.clinic_addr_dtl"></td>
                                    <td colspan="2"><span class="txt_info ">나머지 주소를 입력해주세요.</span></td>                                    
                                </tr>
                                <tr>
                                    <th><span class="emp">전화번호</span></th>
                                    <td>
                                         <div class="form_select form_inline">
                                            <b-form-select v-model="orintMedclClincTelNo1" class="w100">
                                                <b-form-select-option :value="''">선택</b-form-select-option>
                                                <b-form-select-option v-for="areaCode in telAreaCodes" :key="areaCode" :value="areaCode">{{areaCode}}</b-form-select-option>
                                            </b-form-select> -
                                            <input type="text" class="form_control" v-model="orintMedclClincTelNo2" maxlength="4" pattern="[0-9]*" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');">-
                                            <input type="text" class="form_control" v-model="orintMedclClincTelNo3" maxlength="4" pattern="[0-9]*" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');">
                                        </div>     
                                    </td>
                                    <th><span>팩스번호</span></th>
                                    <td>
                                        <div class="form_select form_inline">
                                            <b-form-select v-model="orintMedclClincFaxNo1" class="w100">
                                                <b-form-select-option :value="''">선택</b-form-select-option>
                                                <b-form-select-option v-for="areaCode in telAreaCodes" :key="areaCode" :value="areaCode">{{areaCode}}</b-form-select-option>
                                            </b-form-select> -
                                            <input type="text" class="form_control" v-model="orintMedclClincFaxNo2" maxlength="4" pattern="[0-9]*" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');">-
                                            <input type="text" class="form_control" v-model="orintMedclClincFaxNo3" maxlength="4" pattern="[0-9]*" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');">
                                        </div>     
                                    </td>
                                </tr>
                                <tr>
                                    <th><span class="emp">실무자 성함</span></th>
                                    <td><input type="text" class="form_control" v-model="dispsrMbrInfo.clinic_official_nm"></td>
                                    <th><span>직책</span></th>
                                    <td><input type="text" class="form_control" v-model="dispsrMbrInfo.clinic_official_position"></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>           
                    <div class="btn_box">
                        <button 
                            class="btn btn_md btn_brown btn_outline"
                            @click="currentStep = 0"
                        >
                            취소
                        </button>
                        <button 
                            class="btn btn_md btn_brown"
                            @click="fn_join()"
                        >
                            회원가입
                        </button>
                    </div>                               
                </article>                
                    <alert-modal 
                        :id="'alert'"
                        :text="showAlertMsg" 
                        :btnRight="'확인'" 
                        :oneBtn="false"
                        :isShow="showAlert"
                        :className="'btn_brown'"
                        v-on:update:showSetting="fn_showSet"
                    />
            </div>              
</template>

<script>
    import axios from 'axios'
    import AlertModal from "@/modal/common/alertModal.vue"
    import alertutill from "@/mixin/alertModalUtill";
    import commonUtil from "@/mixin/commonUtil";
    
    export default {
        name: 'UserJoin',
        components: {
            'alert-modal' : AlertModal,
            //'confirm-modal': AlertModal,
        },
        mixins: [alertutill,commonUtil],
        data () {
            return {              
                currentStep: 0,
                selected: null,                
                duplicationChk : 'N',
                birthYearList : [],
                birthMonthList: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
                birthDayList : [],
                phonePrefixes: ['010', '011', '016', '017', '018', '019'],
                dispsrMbrCpNo1 : '',
                dispsrMbrCpNo2 : '',
                dispsrMbrCpNo3 : '',
                telAreaCodes: [
                                '02',   // 서울
                                '031', '032', '033', // 경기, 인천, 강원
                                '041', '042', '043', // 충청
                                '051', '052', '053', '054', '055', // 경상
                                '061', '062', '063', // 전라
                                '064'  // 제주
                            ],
                dispsrMbrTelNo1 : '',
                dispsrMbrTelNo2 : '',
                dispsrMbrTelNo3 : '',
                mailDomain: ['gmail.com', 'naver.com', 'daum.net', 'hanmail.net', 'hotmail.com'],
                doctor_mail : '',
                doctor_mail_domain : '',
                doctor_select_domain : '',
                orintMedclClincTelNo1 : '',
                orintMedclClincTelNo2 : '',
                orintMedclClincTelNo3 : '',
                orintMedclClincFaxNo1 : '',
                orintMedclClincFaxNo2 : '',
                orintMedclClincFaxNo3 : '',
                bizRegNum1 : '',
                bizRegNum2 : '',
                bizRegNum3 : '',
                dispsrMbrInfo : {
                    clinic_doctor_id : '',
                    clinic_doctor_pw : '',
                    clinic_doctor_pw_confirm : '',
                    doctor_nm : '',
                    clinic_doctor_class : '',
                    doctor_gender : 'M',
                    doctor_birth_year : '',
                    doctor_birth_month : '',
                    doctor_birth_day : '',
                    doctor_post_no : '',
                    doctor_addr : '',
                    doctor_addr_dtl : '',
                    doctor_phone_num : '',
                    doctor_tel_num : '',
                    doctor_email : '',
                    messageRecvYn : 'Y',
                    mailRecvYn : 'Y',
                    licenseNo : '',
                    issuanceDate : '',
                    clinic_nm : '',
                    clinic_business_num : '',                    
                    clinic_post_no : '',
                    clinic_addr : '',
                    clinic_addr_dtl : '',
                    clinic_tel_num : '',
                    clinic_fax_num : '',  
                    clinic_official_nm : '',
                    clinic_official_position : '',
                    nick_nm : ''
                },           
                menuList: [
                    {
                        subTitle: '한의원(개원의), 병원(요양병원, 한방병원), 보건소',
                        title: '의료기관'
                    },
                    {
                        subTitle: '미 개원의, 한의대(한의전) 졸업생',
                        title: '한의사'
                    }
                ],
                selectedBox: {                      
                    select1: null,
                    select2: null, 
                    select3: null,
                    select4: null,
                    select5: null,
                    select6: null,
                    years: null, 
                    month: null,
                    day: null,
                },           
            }
        },
        computed: {
            joinUserDivision () {
                if (this.selected === null) return
                const user = {
                    0: '의료기관',
                    1: '한의사(일반)'
                }[this.selected]
                return user
            }
        },
        created(){
            this.currentTab = 0;

            //생년월일 년도 구하기 
            const currentYear = new Date().getFullYear();
            const startCentury = Math.floor((currentYear - 100) / 100) * 100;
            for (let y = currentYear; y >= startCentury; y--) {
                this.birthYearList.push(y)
            }
        },
        methods: {
            fn_move_main(){            
                this.$router.push("/");
            },
            fn_move_tab(currentTab){
                //네이게이션 타이틀 변경처리
                this.currentStep = currentTab

                if(this.currentStep == 1){
                    this.$parent.title = "회원구분";
                }else if(this.currentStep == 2){
                    this.$parent.title = "회원가입";   
                }

            },
            fn_userchk(){
                
                let param = new Object();

                // 회원구분이 의료기관인 경우
                if(this.selected == 0){                    
                    param.bizRegNum = this.bizRegNum1+this.bizRegNum2+this.bizRegNum3;

                    console.log("@@@@ res : %o",param.bizRegNum.length);
                    
                    if(this.bizRegNum1 == '' || this.bizRegNum2 == '' || this.bizRegNum3 == ''){
                        let msg = "사업자 등록번호를 입력해주세요";
                        this.fn_open_alert(msg);
                        return;
                    }else if(param.bizRegNum.length != 10){
                       let msg = "사업자 등록번호를 확인해주세요";
                       this.fn_open_alert(msg);
                       return;
                    }

                    //사업자 정보 확인
                    axios
                        .post("/api/user/login/join/chkBizRegNum", param)
                        .then((res) => {                            
                            console.log("@@@@ res : %o",res);

                            if(res.data.result == 'ok'){
                                this.dispsrMbrInfo.clinic_business_num = param.bizRegNum;
                                this.currentStep = 2;
                            }else{                                
                                let msg = "등록된 사업자등록번호입니다.";
                                 this.fn_open_alert(msg);                                 
                            }
                            
                        })
                        .catch((err) => console.log(err));

                        // this.dispsrMbrInfo.clinic_business_num = param.bizRegNum;
                        // this.currentStep = 2;
                }else{

                    if(this.dispsrMbrInfo.doctor_nm == ''){
                        let msg = "이름을 입력해주세요";
                        this.fn_open_alert(msg);
                        return;
                    }else if(this.dispsrMbrInfo.licenseNo == ''){
                        let msg = "면허번호를 입력해주세요";
                        this.fn_open_alert(msg);
                        return;
                    }else if(this.dispsrMbrInfo.licenseNo.length != 5){
                        let msg = "면허번호를 확인해주세요";
                        this.fn_open_alert(msg);
                        return;
                    }

                    //한의사 정보 확인
                    axios
                        .post("/api/user/login/join/chkDispsrMbr", this.dispsrMbrInfo)
                        .then((res) => {                            
                            console.log("@@@@ res : %o",res);

                            if(res.data.result == 'ok'){
                                this.currentStep = 2;
                            }else{                                
                                let msg = "이미 등록되어있는 ID입니다";
                                 this.fn_open_alert(msg);                                 
                            }
                            
                        })
                        .catch((err) => console.log(err));

                    //this.currentStep = 2;
                }
            },            
            callBackAddr(call,postInfo){
                
                console.log("@@@@ postInfo : %o",postInfo);

                if(call == 'mbr'){
                    this.dispsrMbrInfo.doctor_post_no = postInfo.zonecode;
                    this.dispsrMbrInfo.doctor_addr = postInfo.roadAddress;
                }else if(call == 'clinc'){
                    this.dispsrMbrInfo.clinic_post_no = postInfo.zonecode;
                    this.dispsrMbrInfo.clinic_addr = postInfo.roadAddress;
                }
            },
            fn_changeId(){
                this.duplicationChk = 'N';
            },
            fn_chkDuplication(){
                
                let param = new Object();
                param.dispsrMbrId = this.dispsrMbrInfo.dispsrMbrId
                                    //한의사 정보 확인
                axios
                    .post("/api/user/login/join/chkDuplicationid", param)
                    .then((res) => {                            
                        console.log("@@@@ res : %o",res);

                        if(res.data.result == 'ok'){
                            let msg = "사용할 수 있는 ID입니다";
                            this.fn_open_alert(msg);                                 
                            this.duplicationChk = 'Y';
                        }else{                                
                            let msg = "이미 등록되어있습니다.";
                            this.fn_open_alert(msg);                                 
                        }
                        
                    })
                    .catch((err) => console.log(err));
            },
            fn_join(){
                if(this.fn_validation_chk()){

                    if(this.selected == 0){
                        this.dispsrMbrInfo.clinic_doctor_class = 'C'
                    }else{
                        this.dispsrMbrInfo.clinic_doctor_class = 'P'
                    }

                    console.log("@@@@@ dispsrMbrInfo : %o",this.dispsrMbrInfo);

                    axios
                        .post("/api/user/login/join/regMbrInfo", this.dispsrMbrInfo)
                        .then((res) => {                            
                            console.log("@@@@ res : %o",res);

                            if(res.data.result == 'ok'){
                                let msg = "회원가입이 완료되었습니다.";
                                this.fn_open_alert(msg);                                 
                                this.duplicationChk = 'Y';

                                this.$router.push({ name: 'UserLogin'}); 
                                
                            }
                            
                        })
                        .catch((err) => console.log(err));
                }
                
            },
            fn_validation_chk(){
                
                // console.log("validation chk")

                let msg = "";
                // //validation 체크
                if(this.dispsrMbrInfo.clinic_doctor_id == ''){
                    msg = "ID를 입력해주세요";
                    this.fn_open_alert(msg);    
                    return false;
                }else{
                    var regType = /^[A-Za-z0-9]{6,12}$/;
                    if (!regType.test(this.dispsrMbrInfo.clinic_doctor_id)){
                        msg = "잘못된 입력된 ID입니다.";
                        this.fn_open_alert(msg);
                        return false;
                    }     
                }

                if(this.dispsrMbrInfo.clinic_doctor_pw == ''){
                    msg = "비밀번호를 입력해주세요";
                    this.fn_open_alert(msg);    
                    return false;
                }else if(this.dispsrMbrInfo.clinic_doctor_pw != this.dispsrMbrInfo.clinic_doctor_pw_confirm){
                    msg = "비밀번호가 일치하지 않습니다";
                    this.fn_open_alert(msg);    
                    return false;
                }
                
                
                if(this.dispsrMbrInfo.dispsrMbrNm == ''){
                    msg = "이름을 입력해주세요";
                    this.fn_open_alert(msg);    
                    return false;
                }
                if(this.dispsrMbrInfo.nick_nm == ''){
                    msg = "닉네임을 입력해주세요";
                    this.fn_open_alert(msg);    
                    return false;
                }

                if(this.dispsrMbrInfo.doctor_birth_year == ''){
                    msg = "생년월일의 년도를 입력해주세요";
                    this.fn_open_alert(msg);    
                    return false;
                }else if(this.dispsrMbrInfo.doctor_birth_month == ''){
                    msg = "생년월일의 월을 입력해주세요";
                    this.fn_open_alert(msg);    
                    return false;
                }else if(this.dispsrMbrInfo.dispsrMbrBirthDay == ''){
                    msg = "생년월일의 날짜를 입력해주세요";
                    this.fn_open_alert(msg);    
                    return false;
                }

                if(this.dispsrMbrInfo.doctor_post_no == '' || this.dispsrMbrInfo.doctor_addr == ''){
                    msg = "주소검색을 해주세요";
                    this.fn_open_alert(msg);    
                    return false;
                }

                if(this.dispsrMbrCpNo1 == '' || this.dispsrMbrCpNo2 == '' || this.dispsrMbrCpNo3 == ''){
                    msg = "휴대전화번호를 입력해주세요";
                    this.fn_open_alert(msg);    
                    return false;
                }else if(this.dispsrMbrCpNo2.length < 3 && this.dispsrMbrCpNo2.length > 4){
                    msg = "잘못된 휴대전화번호입니다.";
                    this.fn_open_alert(msg);    
                    return false;
                }else if(this.dispsrMbrCpNo3.length != 4){
                    msg = "잘못된 휴대전화번호입니다.";
                    this.fn_open_alert(msg);    
                    return false;
                }else{
                    this.dispsrMbrInfo.doctor_phone_num = this.dispsrMbrCpNo1.toString()+this.dispsrMbrCpNo2.toString()+this.dispsrMbrCpNo3.toString();
                }


                if(this.dispsrMbrTelNo1 && typeof this.dispsrMbrTelNo1 === 'string' && this.dispsrMbrTelNo1.trim() !== ''){
                    
                    if(this.dispsrMbrTelNo2.length < 3 || this.dispsrMbrTelNo2.length > 4){
                        msg = "잘못된 전화번호입니다.";
                        this.fn_open_alert(msg);    
                        return false;
                    }
                    if(this.dispsrMbrTelNo3.length != 4 ){
                        msg = "잘못된 전화번호입니다.";
                        this.fn_open_alert(msg);    
                        return false;
                    }

                    this.dispsrMbrInfo.doctor_tel_num = this.dispsrMbrTelNo1.toString()+this.dispsrMbrTelNo2.toString()+this.dispsrMbrTelNo3.toString();
                    
                }else{
                    this.dispsrMbrTelNo2 = '';
                    this.dispsrMbrTelNo3 = '';
                }

                if(this.doctor_mail != '' || this.doctor_mail_domain != ''){
                    if(this.doctor_mail == ''){
                        msg = "Email ID를 입력해주세요";
                        this.fn_open_alert(msg);    
                        return false;
                    }else if(this.doctor_mail_domain == ''){
                        msg = "Email 정보를 입력해주세요";
                        this.fn_open_alert(msg);    
                        return false;
                    }

                    this.dispsrMbrInfo.doctor_email = this.doctor_mail + '@' + this.doctor_mail_domain;
                }

                //한의원 등록인 경우
                if(this.selected == 0){
                    if(this.dispsrMbrInfo.orintMedclClincNm == ''){
                        msg = "한의원명을 입력해주세요";
                        this.fn_open_alert(msg);    
                        return false;
                    }

                    if(this.dispsrMbrInfo.clinic_post_no == '' || this.dispsrMbrInfo.clinic_addr == ''){
                        msg = "한의원 주소검색을 해주세요";
                        this.fn_open_alert(msg);    
                        return false;
                    }
                    

                    if(this.orintMedclClincTelNo1 == '' || this.orintMedclClincTelNo2 == '' || this.orintMedclClincTelNo3 == ''){
                        msg = "한의원 전화번호를 입력해주세요";
                        this.fn_open_alert(msg);    
                        return false;
                    }if(this.orintMedclClincTelNo1 && typeof this.orintMedclClincTelNo1 === 'string' && this.orintMedclClincTelNo1.trim() !== ''){
                    
                        if(this.orintMedclClincTelNo2.length < 3 || this.orintMedclClincTelNo2.length > 4){
                            msg = "잘못된 한의원 전화번호입니다.";
                            this.fn_open_alert(msg);    
                            return false;
                        }
                        if(this.orintMedclClincTelNo3.length != 4 ){
                            msg = "잘못된 한의원 전화번호입니다.";
                            this.fn_open_alert(msg);    
                            return false;
                        }

                        this.dispsrMbrInfo.clinic_tel_num = this.orintMedclClincTelNo1.toString()+this.orintMedclClincTelNo2.toString()+this.orintMedclClincTelNo3.toString();
                        
                    }else{
                        this.orintMedclClincTelNo2 = '';
                        this.orintMedclClincTelNo3 = '';
                    }

                    if(this.orintMedclClincFaxNo1 && typeof this.orintMedclClincFaxNo1 === 'string' && this.orintMedclClincFaxNo1.trim() !== ''){
                    
                        if(this.orintMedclClincFaxNo2.length < 3 || this.orintMedclClincFaxNo2.length > 4){
                            msg = "잘못된 팩스 전화번호입니다.";
                            this.fn_open_alert(msg);    
                            return false;
                        }
                        if(this.orintMedclClincFaxNo3.length != 4 ){
                            msg = "잘못된 팩스 전화번호입니다.";
                            this.fn_open_alert(msg);    
                            return false;
                        }

                        this.dispsrMbrInfo.clinic_fax_num = this.orintMedclClincFaxNo1.toString()+this.orintMedclClincFaxNo2.toString()+this.orintMedclClincFaxNo3.toString();
                        
                    }else{
                        this.orintMedclClincFaxNo2 = '';
                        this.orintMedclClincFaxNo3 = '';
                    }

                    if(this.dispsrMbrInfo.clinic_official_nm == ''){
                        msg = "실무자명을 입력해주세요";
                        this.fn_open_alert(msg);    
                        return false;
                    }
                }

                return true;
            },
            fn_licenseFileUpload(){
                let fileInputElement = this.$refs.licenseFile;
                fileInputElement.click();
            },
            fn_fileLicenseChange(e){
                this.upLoadFile.upFile = e.target.files[0];
                this.dispsrMbrInfo.licenseFileNm = this.upLoadFile.upFile.name;
            },
            fn_bizRegNumFileUpload(){
                let fileInputElement = this.$refs.bizRegNumFile;
                fileInputElement.click();
            },
            fn_fileBizRegNumChange(e){
                this.upLoadFile.upFile2 = e.target.files[0];
                this.dispsrMbrInfo.bizRegNumFileNm = this.upLoadFile.upFile2.name;
            },
            fn_updateBirthDays() {
                //생년월일 날짜 계산
                if (!this.dispsrMbrInfo.doctor_birth_year || !this.dispsrMbrInfo.doctor_birth_month) {
                    this.birthDayList = []
                    return
                }

                const year = parseInt(this.dispsrMbrInfo.doctor_birth_year)
                const month = parseInt(this.dispsrMbrInfo.doctor_birth_month)
                const daysInMonth = new Date(year, month, 0).getDate()

                this.days = []
                for (let d = 1; d <= daysInMonth; d++) {
                    this.birthDayList.push(d)
                }

                // 선택한 날짜가 현재 달에 없는 경우 초기화
                if (this.dispsrMbrInfo.doctor_birth_day > daysInMonth) {
                    this.dispsrMbrInfo.doctor_birth_day = ''
                }
            },
            fn_change_mail_domain(){
                if(this.doctor_select_domain == null || this.doctor_select_domain == ''){
                    this.doctor_mail_domain = '';
                }else{
                    this.doctor_mail_domain = this.doctor_select_domain;
                }
            }
        }
        
    }
</script>

